import { useSelector } from "react-redux";
import {  Input, Flex, Grid, Form } from "antd";
import "../index.scss";
import InputField from "../../../components/Input/Input";
import { setFormField } from "../TransferEntrySlice";
import { useDispatch } from "react-redux";
import InputNumberField from "../../../components/Input/InputNumber";

const { useBreakpoint } = Grid;

const TransferFooter = ({authInfo}) => {
  const dispatch = useDispatch();
  const { itemsList, footerValues } = useSelector(
    (state) => state.transferEntry
  );
  const screens = useBreakpoint();
  const currency = authInfo?.currency;

  // 🔹 Auto-calc subtotal every time itemsList changes
  const subTotal = itemsList.reduce(
    (sum, item) => sum + (item.quantity || 0) * (item.rate || 0),
    0
  );

  const grandTotal = subTotal + (footerValues.serviceCharge || 0);

  return (
    <Form
      layout="horizontal"
      colon={false}
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 18 }}
      style={{
        maxWidth: "1400px",
        marginTop: "24px",
      }}
    >
      <Flex
        gap={!screens.md || !screens.xl ? 10 : 80}
        justify="center"
        style={{
          flexDirection: !screens.md || !screens.xl ? "column" : "row",
          width: "100%",
          marginBottom: "24px",
        }}
      >
        <Flex
          vertical
          gap={10}
          style={{
            width: !screens.md || !screens.xl ? "100%" : "40%",
          }}
        >
          <Form.Item
            label={`Service Charge (${currency})`}
            // name={"service_charge"}
            rules={[{ required: true, message: "Service Charge" }]}
          >
            <InputNumberField
              value={footerValues.serviceCharge}
              onClick={() => {
                if (footerValues.serviceCharge !== null) {
                  dispatch(
                    setFormField({
                      field: "footerValues",
                      value: {
                        ...footerValues,
                        serviceCharge: null,
                      },
                    })
                  );
                }
              }}
              onChange={(e) => {
                dispatch(
                  setFormField({
                    field: "footerValues",
                    value: { ...footerValues, serviceCharge: e },
                  })
                );
              }}
            />
          </Form.Item>
          <Form.Item label="Description / Narration">
            <Input.TextArea
              rows={3}
              value={footerValues.narration}
              onChange={(e) =>
                dispatch(
                  setFormField({
                    field: "footerValues",
                    value: { ...footerValues, narration: e.target.value },
                  })
                )
              }
            />
          </Form.Item>
        </Flex>
        <Flex
          vertical
          gap={10}
          style={{
            width: !screens.md || !screens.xl ? "100%" : "40%",
          }}
        >
          <Form.Item label={`Sub Total (${currency})`} style={{ flex: 1 }}>
            <InputField disabled value={(subTotal || 0).toFixed(2)} />
          </Form.Item>
          <Form.Item
            label={`Grand Total (${currency})`}
          >
            <InputField
              disabled
              value={(grandTotal || 0).toFixed(2)}
            />
          </Form.Item>
        </Flex>
      </Flex>
    </Form>

    // <Row gutter={16} style={{ marginTop: 20 }}>
    //   <Col span={8}>
    //     <div>Sub Total</div>
    //     <Input value={subTotal} disabled />
    //   </Col>
    //   <Col span={8}>
    //     <div>Service Charge</div>
    //     <Input value={footerValues.serviceCharge} disabled />
    //   </Col>
    //   <Col span={8}>
    //     <div>Total Discount</div>
    //     <Input value={grandTotal} disabled />
    //   </Col>
    // </Row>
  );
};

export default TransferFooter;
